import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
import { CTAButton } from './CTAButton';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-16" data-id="element-33" data-mp="3ogau3n1a2v3q">
      <div className="mx-auto max-w-3xl" data-id="element-34" data-mp="3oi41x5nmnldb">
        <h2 className="text-center font-serif text-[28px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-35" data-mp="3sglaltmp53wu">
          Deja de improvisar. Empieza a seguir una{' '}
          <span className="italic text-brand" data-id="element-36" data-mp="3jgoifi13lmx1">Ruta Clínica</span>.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy-700/80" data-id="element-37" data-mp="3jirfun4kyibs">
          Miles de páginas de guías internacionales se transforman en un único
          sistema de decisiones que puedes aplicar desde tu siguiente consulta.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-38" data-mp="2vsf2uxuh9vec">
          <div className="rounded-2xl border border-red-100 bg-red-50/60 p-5" data-id="element-39" data-mp="30px8ofd77ui4">
            <p className="flex items-center gap-2 text-[12px] font-extrabold uppercase tracking-[0.16em] text-red-700" data-id="element-40" data-mp="30s02zbldw9sn">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-red-600" data-id="element-41" data-mp="t3i1sbqop815">
                <XIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-42" data-mp="1739mevbphmo4" />
              </span>
              Antes
            </p>
            <ul className="mt-4 space-y-3" data-id="element-43" data-mp="124yc6jhi1a5d">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-44" data-mp="ef4044507pm6">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-45" data-mp="9ezl6ijqv2y2" />
                  <span className="text-[14px] leading-snug text-navy-900/80" data-id="element-46" data-mp="o5gj3rx67aq7">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-teal/25 bg-teal-light/60 p-5" data-id="element-47" data-mp="3rre5jfeczjhd">
            <p className="flex items-center gap-2 text-[12px] font-extrabold uppercase tracking-[0.16em] text-teal" data-id="element-48" data-mp="3msujzg3og9pj">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-teal" data-id="element-49" data-mp="1qq7vffxqj5we">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-50" data-mp="1vo9ew1z2p78e" />
              </span>
              Con Ruta Clínica GLP-1
            </p>
            <ul className="mt-4 space-y-3" data-id="element-51" data-mp="24hmcvibzuz1c">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-52" data-mp="17t6mjk128ln6">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-53" data-mp="1cqosd1js6kqy" />
                  <span className="text-[14px] font-medium leading-snug text-navy-900" data-id="element-54" data-mp="1gr8kfqphyy68">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-55" data-mp="2sa2wvyfal13a">
          <CTAButton label="Quiero mi Ruta Clínica hoy" note="Acceso inmediato · USD $15 pago único" data-id="element-56" data-mp="2x5s32klthg8k" />
        </div>
      </div>
    </section>;
}